import React from 'react';
import {Link} from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="page-title__area pt-110 bg-danger">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-12">
                        <div className="page__title-wrapper text-center">
                            <h3 className="fw-bold">404 Not Found</h3>
                        </div>
                        <nav className="pb-70">
                            <ul className="breadcrumb justify-content-center">
                                <li className="bd-items">
                                    <Link className="nav-link" to={"/"}>HOME</Link>
                                </li>
                                <li className="bd-items bdritems">|</li>
                                <li className="bd-items active fw-bold"> 404</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default NotFound;